import React from 'react';
import { MAIN_CONFIG } from '../../../config/main';

export default ({ id, className, color = MAIN_CONFIG.COLORS.fillBlue, width = "35", height = "25", secondaryColor = MAIN_CONFIG.COLORS.fillRed }) => {
    return (
        <svg id={id} className={className} width={width} height={height} viewBox="0 0 35 25" xmlns="http://www.w3.org/2000/svg">
            <title>Diners Club</title>
            <g fill="none" fillRule="evenodd">
                <rect width="35" height="25" fill="#2283CB" rx="4"></rect>
                <path fill="#FFF" fillRule="nonzero" d="M18.98 5a7.57 7.57 0 0 1 7.63 7.5v.07A7.64 7.64 0 0 1 18.98 20h-2.67A7.45 7.45 0 0 1 9 12.57 7.29 7.29 0 0 1 15.97 5h3zM16.5 6.3c-3.39 0-6.2 2.8-6.2 6.2 0 3.4 2.81 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2 0-3.4-2.8-6.2-6.2-6.2z"></path>
                <path fill="#FFF" fillRule="nonzero" d="M17.48 16.67V8.4a4.26 4.26 0 0 1 0 8.28zm-1.96 0a4.29 4.29 0 0 1 0-8.28v8.28z"></path>
            </g>
        </svg>
    );
};
